let Backbone = require("backbone");
let BillModel = require("../model/BillModel.js");

let main = function (Backbone, BillModel) {
    return Backbone.Collection.extend({
        model: BillModel,
        comparator: function (b1, b2) {
            if (!b1.id && !b2.id) {
                return b1.getCheckInTime() - b2.getCheckInTime();
            } else if (!b1.id && b2.id) {
                return 1;
            } else if (b1.id && !b2.id) {
                return -1;
            } else if (b1.id && b2.id) {
                return b1.id - b2.id;
            }
            return 0;
        }
    });
};

let exportedValue = main(Backbone, BillModel);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/collection/BillCollection.js